(function(){

  'use strict';

  function pxTabs() {
    return {
      restrict: 'EA',
      scope: {
        tabsObject: '=tabsObject',
        activeTab: '=activeTab',
        callback: '&callback'
      },
      templateUrl: 'app/directives/tabsDirective/tabs.template.html',
      link: function(scope) {

        scope.tabs = null;
        scope.tabs = scope.tabsObject;

        
        (function() {
          initTabs();
          setListeners();
        })();
        
        function initTabs () {
          for(var i = 0; i < scope.tabsObject.length; i++) {
            if (scope.tabsObject[i].section === scope.activeTab) {
              scope.tabsObject[i].selected = true;
            } else {
              scope.tabsObject[i].selected = false;
            }
          }
        }

        scope.selectTab = function (selectedTab) {
          scope.callback({selectedTab: selectedTab.section});
        }

        function setListeners () {
          scope.$watch(function() {
            return scope.activeTab
          }, function (newActiveTab, oldActiveTab) {
            if (newActiveTab !== oldActiveTab);
            initTabs();
          })
        }
      }
    };
  }

  pxTabs.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxTabs', pxTabs);

})();
